import { PageMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { PetitionUnderReviewBanner } from 'src/app/shared/components/banners/petitionUnderReview';

import { usePageBanner } from './hooks/usePageBanner';

export function PageBanner() {
	const {
		data: { message, showUnderReviewBanner },
	} = usePageBanner();

	return (
		<>
			{showUnderReviewBanner && <PetitionUnderReviewBanner />}
			{message && <PageMessage role="alert" message={message} severity="critical" />}
		</>
	);
}
